<template>
  <div>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              Committee Positions
            </th>
            <th class="text-left">
              Member Name
            </th>                      
            <th class="text-left">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in members" :key="item.uuid">
            <td>{{ item.position }}</td>
            <td v-if="item.member">{{ item.member.display_name }}</td>           
            <td><v-icon color="red" @click="deleteMember(item.uuid)">
                mdi-delete-circle
            </v-icon></td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: "MembersList",

  props: ["members"],
  components: {},

  data: () => ({
    loading: false,
  }),

  methods: {
    submit() {
      this.loading = true;
    },
    deleteMember(id){  
    this.$emit('deleteMember', id);
    }
  },
};
</script>
